// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + ".variant." + "269edb82228df5a6d8e4" + ".js";
};